const storage = {
  get(key) {
    try {
      const raw = window.localStorage.getItem(key)
      if (raw == null) return null
      return JSON.parse(raw)
    } catch (e) {
      return null
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      return false
    }
    return true
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key)
    } catch (e) {
      return false
    }
    return true
  }
}

export default storage
